/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {
 *         body: "string"
 *     }
 */
export interface CredentialSignRequest {
    /** All supported DID methods. Default is "web". */
    didMethod?: Truvity.CredentialSignRequestDidMethod;
    /** The unsigned credential to sign. */
    body: string;
}
